// extracted by mini-css-extract-plugin
export default {"container":"lOrLG","label":"Hw2DW","discount":"XuSw0","type":"_22Vni","novelty":"_4szU7","skeleton-progress":"KJym1"};